import { render } from "./PlayControl.vue?vue&type=template&id=1aacc3a5&scoped=true"
import script from "./PlayControl.vue?vue&type=script&lang=ts"
export * from "./PlayControl.vue?vue&type=script&lang=ts"

import "./PlayControl.vue?vue&type=style&index=0&id=1aacc3a5&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-1aacc3a5"

export default script